import type { CurriculumPack } from '@/content/schema';
import { meta } from './meta';
import * as arabic from './subjects/arabic';
import * as english from './subjects/english';
import * as french from './subjects/french';
import * as math from './subjects/math';
import * as science from './subjects/science';

const subjects = [math, arabic, french, english, science];

/** Tunisian primary sample pack (unvalidated). Validated with zod when loaded. */
export const tnPrimaryPack: CurriculumPack = {
  ...meta,
  subjects: subjects.map((s) => s.subject),
  domains: subjects.flatMap((s) => s.domains),
  objectives: subjects.flatMap((s) => s.objectives),
  lessons: subjects.flatMap((s) => s.lessons),
  items: subjects.flatMap((s) => s.items),
};
